export default __webpack_public_path__ + "static/media/tram.67c1be51.svg";